import { CurrentProject } from "./CurrentWork";

export const MailchimpForm = () => {
  return <CurrentProject />;
};
